import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { fetchMegaMenu } from 'Api/Algolia/algolia-calls';
import { xboxAvailable } from 'Helpers/Geo/data';
import store from 'Redux/store';
import CategoriesMegaMenu from 'Layout/NavBar/MegaMenu/CategoriesMegaMenu';
import DiscoverMegaMenu from 'Layout/NavBar/MegaMenu/DiscoverMegaMenu';
import BundlesMegaMenu from 'Layout/NavBar/MegaMenu/BundlesMegaMenu';
import FantasyVerseMegaMenu from 'Layout/NavBar/MegaMenu/FantasyVerseMegaMenu';

function MegaMenusContainer({ megaMenuTab, setMegaMenuTab }) {
  const [algoliaData, setAlgoliaData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await store.dispatch(fetchMegaMenu());
      return setAlgoliaData(data);
    };
    fetchData();
  }, []);

  if (isEmpty(algoliaData)) return false;

  const topSellerHits = get(algoliaData, 'topSellers', []);
  const newReleaseHits = get(algoliaData, 'newReleases', []);
  const comingSoonHits = get(algoliaData, 'comingSoon', []);
  const onSaleHits = get(algoliaData, 'onSale', []);
  const endingSoonHits = get(algoliaData, 'endingSoon', []);
  const latestDealsHits = get(algoliaData, 'latestDeals', []);
  const popularGamesHits = get(algoliaData, 'popularGames', []);
  const bundleHits = get(algoliaData, 'bundles', []);
  const gameBundleHits = get(algoliaData, 'gameBundles', []);
  const bookBundleHits = get(algoliaData, 'bookBundles', []);
  const softwareBundleHits = get(algoliaData, 'softwareBundles', []);
  const gamesUnderFiveHits = get(algoliaData, 'gamesUnderFive', []);
  const bestOfGamesOf2025 = get(algoliaData, 'hallOfFame', []);
  const freeToPlay = get(algoliaData, 'freeToPlay', []);
  const featured = get(algoliaData, 'featured[0]');
  const featuredSecond = get(algoliaData, 'featured[1]');
  const xboxHits = get(algoliaData, 'xbox', []);
  const fantasyVerseComicBookDay = get(algoliaData, 'fantasyVerseComicBookDay', []);
  const fantasyVerseTopSellers = get(algoliaData, 'fantasyVerseTopSellers', []);

  return (
    <React.Fragment>
      <DiscoverMegaMenu
        setMegaMenuTab={setMegaMenuTab}
        megaMenuTab={megaMenuTab}
        topSellerHits={topSellerHits}
        newReleaseHits={newReleaseHits}
        comingSoonHits={comingSoonHits}
        endingSoonHits={endingSoonHits}
        latestDealsHits={latestDealsHits}
        popularGamesHits={popularGamesHits}
        gameBundleHits={gameBundleHits}
        gamesUnderFiveHits={gamesUnderFiveHits}
        bestOfGamesOf2025={bestOfGamesOf2025}
        freeToPlay={freeToPlay}
        xboxHits={xboxHits}
        featured={featured}
        featuredSecond={featuredSecond}
        onSaleHits={onSaleHits}
      />

      <CategoriesMegaMenu
        setMegaMenuTab={setMegaMenuTab}
        megaMenuTab={megaMenuTab}
        xboxAvailable={xboxAvailable}
      />

      <BundlesMegaMenu
        setMegaMenuTab={setMegaMenuTab}
        megaMenuTab={megaMenuTab}
        bundleHits={bundleHits}
        gameBundleHits={gameBundleHits}
        bookBundleHits={bookBundleHits}
        softwareBundleHits={softwareBundleHits}
      />

      <FantasyVerseMegaMenu
        setMegaMenuTab={setMegaMenuTab}
        megaMenuTab={megaMenuTab}
        fantasyVerseComicBookDay={fantasyVerseComicBookDay}
        fantasyVerseTopSellers={fantasyVerseTopSellers}
      />

    </React.Fragment>
  );
}

MegaMenusContainer.propTypes = {
  megaMenuTab: PropTypes.string,
  setMegaMenuTab: PropTypes.func,
};

MegaMenusContainer.defaultProps = {
  megaMenuTab: '',
  setMegaMenuTab: () => { },
};

export default MegaMenusContainer;
